import {isDate} from 'lodash';
export default {
    data: () => ({
        overrideProps: null
    }),
    methods: {
        setProp(prop, value) {
            let parent = this.$parent;
            if (parent && parent.$options.name &&  parent.$options.name.startsWith('zoezi-')) {
                parent = parent.$parent;
            }

            let triggerProps = false;
            if (parent && parent.$options.name == 'ComponentWrapper') {
                let config = parent.config;
                if (config.style?.pageParams) {
                    let pageParam = config.style.pageParams.find(p => p.prop == prop);
                    if (pageParam) {
                        let part = pageParam.id == 'id' ? 'params' : 'query';

                        let route = {
                            name: this.$route.name,
                            params: Object.assign({}, this.$route.params),
                            query: Object.assign({}, this.$route.query)
                        }

                        if (isDate(value)) {
                            value = value.yyyymmdd()
                        }

                        let isnull = value == null || value == undefined;
                        if (!isnull) {
                            value = String(value);
                        }
                        if (value != route[part][pageParam.id]) {
                            if (isnull) {
                                delete route[part][pageParam.id];
                            } else {
                                route[part][pageParam.id] = String(value);
                            }
                            this.$router.replace(route);
                        }
                        return;
                    }
                }
                triggerProps = true;
            }

            if (!this.overrideProps) {
                this.overrideProps = {}
            }
            this.$set(this.overrideProps, prop, value)

            if (triggerProps) {
                this.$emit('triggerProps');
            }
        }
    }
}